"use strict";

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = require("recompose");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var enhancedDonutChartProps = (0, _recompose.compose)((0, _recompose.mapProps)(function (_ref) {
  var props = _objectWithoutProperties(_ref, []),
      _ref$sizeRatio = _ref.sizeRatio,
      sizeRatio = _ref$sizeRatio === undefined ? 1 : _ref$sizeRatio,
      _ref$relativeCircumfe = _ref.relativeCircumference,
      relativeCircumference = _ref$relativeCircumfe === undefined ? 100 : _ref$relativeCircumfe;

  return _extends({}, props, {
    width: (80 / sizeRatio).toFixed(2) + "%",
    height: (80 / sizeRatio).toFixed(2) + "%",
    strokeWidth: Math.floor(16 * sizeRatio), // based on sizeRatio to keep the chart size consistent
    radius: relativeCircumference / (2 * Math.PI)
  });
}));

var DonutChart = function DonutChart(_ref2) {
  var _ref2$segments = _ref2.segments,
      segments = _ref2$segments === undefined ? [] : _ref2$segments,
      _ref2$classNames = _ref2.classNames;
  _ref2$classNames = _ref2$classNames === undefined ? {} : _ref2$classNames;
  var hole = _ref2$classNames.hole,
      ring = _ref2$classNames.ring,
      _ref2$maxX = _ref2.maxX,
      maxX = _ref2$maxX === undefined ? 40 : _ref2$maxX,
      _ref2$maxY = _ref2.maxY,
      maxY = _ref2$maxY === undefined ? 40 : _ref2$maxY,
      width = _ref2.width,
      height = _ref2.height,
      strokeWidth = _ref2.strokeWidth,
      radius = _ref2.radius,
      _ref2$startOffset = _ref2.startOffset,
      startOffset = _ref2$startOffset === undefined ? 0 : _ref2$startOffset;
  return _react2.default.createElement(
    "svg",
    {
      width: width,
      height: height,
      viewBox: "0 0 " + maxX + " " + maxY,
      preserveAspectRatio: "xMidYMin slice",
      className: "cxa-donut"
    },
    _react2.default.createElement("circle", {
      className: "cxa-donut__hole",
      cx: maxX / 2,
      cy: maxY / 2,
      r: radius
    }),
    _react2.default.createElement("circle", {
      className: "cxa-donut__ring cxa-donut__colour--default",
      cx: maxX / 2,
      cy: maxY / 2,
      r: radius,
      strokeWidth: strokeWidth
    }),
    segments.map(function (_ref3, i, arr) {
      var _ref3$percentage = _ref3.percentage,
          percentage = _ref3$percentage === undefined ? 0 : _ref3$percentage,
          _ref3$name = _ref3.name,
          name = _ref3$name === undefined ? "donutchart-segment-" + Math.random() : _ref3$name;
      return _react2.default.createElement("circle", {
        key: name,
        className: "cxa-donut__segment cxa-donut__colour--" + i,
        cx: maxX / 2,
        cy: maxY / 2,
        r: radius,
        strokeWidth: strokeWidth,
        strokeDasharray: percentage + " " + (100 - percentage)
        // need to add offset by sum of previously drawn segments subtracted from 100, then add to startOffset
        , strokeDashoffset: i === 0 ? startOffset : 100 - arr.slice(0, i).reduce(function (prev, e) {
          return prev + e.percentage;
        }, 0) + startOffset
      });
    })
  );
};

DonutChart.propTypes = process.env.NODE_ENV !== "production" ? {
  segments: _propTypes2.default.array,
  classNames: _propTypes2.default.object,
  relativeCircumference: _propTypes2.default.number,
  radius: _propTypes2.default.number,
  strokeWidth: _propTypes2.default.number,
  maxX: _propTypes2.default.number,
  maxY: _propTypes2.default.number,
  sizeRatio: _propTypes2.default.number,
  startOffset: _propTypes2.default.number,
  width: _propTypes2.default.string,
  height: _propTypes2.default.string
} : {};

exports.default = enhancedDonutChartProps(DonutChart);
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cxagroup/casper/lib/components/donut-chart/donut-chart.js
// module id = 1360
// module chunks = 249